/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Network_OtherInputs */

const fr_map_network_other = /** @type {(inputs: Map_Network_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autres réseaux`)
};

const en_map_network_other = /** @type {(inputs: Map_Network_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other networks`)
};

/**
* | output |
* | --- |
* | "Other networks" |
*
* @param {Map_Network_OtherInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const map_network_other = /** @type {((inputs?: Map_Network_OtherInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Network_OtherInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_map_network_other(inputs)
	return en_map_network_other(inputs)
});